var map = {
	"./ag.svg": "7dab",
	"./ai.svg": "0ca9",
	"./ar.svg": "59af",
	"./be.svg": "85ca",
	"./bl.svg": "08c4",
	"./bs.svg": "7628",
	"./fr.svg": "8392",
	"./ge.svg": "8906",
	"./gl.svg": "e243",
	"./gr.svg": "a3b3",
	"./ju.svg": "fc07",
	"./lu.svg": "0570",
	"./ne.svg": "018a",
	"./nw.svg": "83a6",
	"./ow.svg": "4853",
	"./sg.svg": "0776",
	"./sh.svg": "8d34",
	"./so.svg": "16bf",
	"./sz.svg": "758e",
	"./tg.svg": "93a7",
	"./ti.svg": "5f9e",
	"./ur.svg": "0174",
	"./vd.svg": "d803",
	"./vs.svg": "ad62",
	"./zg.svg": "51d0",
	"./zh.svg": "58ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "00f7";